import request from "@/http";
/**
 *
 * @param {*} data
 * @returns
 */
const getList = (data) => {
    let { begin_idx, limit, id_public_user_info, isloading = false, type_middle_app = 20005, type_inner_app = 1001, is_online = 0 } = data;
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: begin_idx,
            pre_db_para_length_4_list: limit,
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            pre_db_para_middle_table_name: "public_middle_table_20005",
            id_public_user_info: id_public_user_info,
            is_online: is_online,
            pre_db_para_order_by_para: ' time_insert desc ',
    },
        loading: {
            enabled: isloading
        }
    })
}
// 创建项目
const createDemand = (data) => {
    let { mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,mid_table_remark_005,mid_table_remark_006,mid_table_remark_007,mid_table_remark_008,mid_table_remark_009,mid_table_remark_010,mid_table_remark_011,mid_table_remark_012,id_public_middle_table,id_public_user_info, isloading = false, type_middle_app = 20005, type_inner_app = 1001, is_online = 0 } = data;
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_insert_or_update_middle_table",
            pre_db_para_id_public_middle_table: id_public_middle_table,
            id_public_user_info: id_public_user_info,
            mid_table_remark_001: mid_table_remark_001,
            mid_table_remark_002: mid_table_remark_002,
            mid_table_remark_003: mid_table_remark_003,
            mid_table_remark_004: mid_table_remark_004,
            mid_table_remark_005: mid_table_remark_005,
            mid_table_remark_006: mid_table_remark_006,
            mid_table_remark_007: mid_table_remark_007,
            mid_table_remark_008: mid_table_remark_008,
            mid_table_remark_009: mid_table_remark_009,
            mid_table_remark_010: mid_table_remark_010,
            mid_table_remark_011: mid_table_remark_011,
            mid_table_remark_012: mid_table_remark_012,
            pre_db_para_middle_table_name: "public_middle_table_20005",
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            is_online: is_online
        },
        loading: {
            enabled: isloading
        }
    })
}

const getDetail = (data) => {
    let { begin_idx, limit, id_public_user_info, id_public_middle_table, isloading = false, type_middle_app = 20005, type_inner_app = 1001, is_online = 0 } = data;
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: begin_idx,
            pre_db_para_length_4_list: limit,
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            pre_db_para_middle_table_name: "public_middle_table_20005",
            id_public_user_info: id_public_user_info,
            id_public_middle_table: id_public_middle_table,
            is_online: is_online
        },
        loading: {
            enabled: isloading
        }
    })
}

// 删除项目
const delDemand = (data) => {
    let { id_public_middle_table, isloading = false, type_middle_app = 20005, type_inner_app = 1001, is_online = 111 } = data;
    return request.post({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_insert_or_update_middle_table",
            pre_db_para_id_public_middle_table: id_public_middle_table,
            pre_db_para_middle_table_name: "public_middle_table_20005",
            is_online: 111,
            type_inner_app: type_inner_app,
            type_middle_app: type_middle_app
        },
        loading: {
            enabled: isloading
        }
    })
}

/*
* 查看需求反馈
* */
const checkFeedBack = (data) => {
    let { begin_idx, limit, id_public_user_info, mid_table_remark_002, isloading = false, type_middle_app = 10001, type_inner_app = 2002, is_online = 0 } = data;
    return request.get({
        url: "duzikai_api_mgr_public_middle_table",
        data: {
            invoke_method: "public_load_middle_table_list",
            pre_db_para_begin_idx: begin_idx,
            pre_db_para_length_4_list: limit,
            type_middle_app: type_middle_app,
            type_inner_app: type_inner_app,
            pre_db_para_middle_table_name: "public_middle_table_10001",
            id_public_user_info: id_public_user_info,
            mid_table_remark_002: mid_table_remark_002,
            is_online: is_online
        },
        loading: {
            enabled: isloading
        }
    })
}

export default {
    getList,
    createDemand,
    getDetail,
    delDemand,
    checkFeedBack
}
